import React from 'react'
import Tabs from './Tabs';
import "./Experties.css"
import { tabData } from '../utils/hire';

function Experties() {
  return (
    <section className='experties-section'>
        <p className='case-title'>Experties</p>
        <h2 className='case-title-p'>Dedicated Development <span>Team Expertise</span></h2>
        <p className='case-description'>We are a leading software development company offering dedicated software developers for hire. We have a team with 2 to 10+ years of experience. Hire dedicated developers with expertise in creating high-quality and scalable applications, irrespective of your business challenges.</p>
        <Tabs tabs={tabData} />

    </section>
  )
}

export default Experties